(() => {
  const initEventsSection = () => {
    document.querySelectorAll("[data-cal-events-section]").forEach((section) => {
      const tabsContainer = section.querySelector("[data-calendar-tabs]");
      const typeInner = section.querySelector(".calendar-tabs-type-inner");
      const typeIndicator = section.querySelector(".calendar-type-indicator");
      const yearsRow = section.querySelector("[data-calendar-years]");
      const yearsInner = yearsRow ? yearsRow.querySelector(".calendar-tabs-years-inner") : null;
      const yearIndicator = section.querySelector(".calendar-year-indicator");
      const panelUpcoming = section.querySelector('[data-panel="upcoming"]');
      const panelArchive = section.querySelector('[data-panel="archive"]');

      if (!tabsContainer) return;

      const typeTabs = tabsContainer.querySelectorAll("[data-tab-type]");
      if (!typeTabs.length) return;

      // Extract unique years from archive rows (already sorted DESC by server)
      const archiveRows = panelArchive
        ? Array.from(panelArchive.querySelectorAll(".cal-events-row[data-year]"))
        : [];
      const archiveYears = [...new Set(archiveRows.map((r) => r.getAttribute("data-year")))];

      // Scroll a tab button to the center of its scrollable parent
      const scrollTabToCenter = (btn) => {
        if (!btn) return;
        const scrollParent = btn.closest(".calendar-tabs-type, .calendar-tabs-years");
        if (!scrollParent) return;
        const parentRect = scrollParent.getBoundingClientRect();
        const btnRect = btn.getBoundingClientRect();
        const scrollLeft = scrollParent.scrollLeft + (btnRect.left - parentRect.left) - (parentRect.width / 2) + (btnRect.width / 2);
        scrollParent.scrollTo({ left: scrollLeft, behavior: "smooth" });
      };

      const updateTypeIndicator = (btn) => {
        if (!typeIndicator || !btn || !typeInner) return;
        const parentRect = typeInner.getBoundingClientRect();
        const btnRect = btn.getBoundingClientRect();
        typeIndicator.style.width = `${btnRect.width}px`;
        typeIndicator.style.height = `${btnRect.height}px`;
        typeIndicator.style.left = `${btnRect.left - parentRect.left}px`;
      };

      const updateYearIndicator = (btn) => {
        if (!yearIndicator || !btn || !yearsInner) return;
        const parentRect = yearsInner.getBoundingClientRect();
        const btnRect = btn.getBoundingClientRect();
        yearIndicator.style.width = `${btnRect.width}px`;
        yearIndicator.style.left = `${btnRect.left - parentRect.left + yearsInner.scrollLeft}px`;
      };

      // Use inline styles to guarantee hiding even if CSS is cached
      const hide = (el) => {
        if (!el) return;
        el.classList.add("hidden");
        el.style.cssText = "display:none!important";
      };
      const show = (el) => {
        if (!el) return;
        el.classList.remove("hidden");
        el.style.cssText = "";
      };

      const showPanel = (name) => {
        if (name === "upcoming") { show(panelUpcoming); hide(panelArchive); }
        else { hide(panelUpcoming); show(panelArchive); }
      };

      const filterArchiveByYear = (year) => {
        archiveRows.forEach((row) => {
          if (row.getAttribute("data-year") === year) show(row);
          else hide(row);
        });
      };

      const buildYearButtons = (initialYear) => {
        if (!yearsInner || !archiveYears.length) return;
        yearsInner.innerHTML = "";

        let defaultIndex = 0;
        if (initialYear) {
          const idx = archiveYears.indexOf(initialYear);
          if (idx >= 0) defaultIndex = idx;
        }

        archiveYears.forEach((year, i) => {
          const btn = document.createElement("button");
          btn.type = "button";
          btn.setAttribute("data-tab-year", year);
          btn.setAttribute("aria-selected", i === defaultIndex ? "true" : "false");
          btn.className =
            "calendar-tab-year whitespace-nowrap py-m text-subheading-lg font-normal transition-colors " +
            (i === defaultIndex
              ? "is-active text-[#950a0a]"
              : "text-neutral-weaker hover:text-neutral-weak");
          btn.textContent = year;
          yearsInner.appendChild(btn);

          btn.addEventListener("click", () => {
            yearsInner.querySelectorAll("[data-tab-year]").forEach((t) => {
              t.classList.remove("is-active", "text-[#950a0a]");
              t.classList.add("text-neutral-weaker");
              t.setAttribute("aria-selected", "false");
            });
            btn.classList.remove("text-neutral-weaker");
            btn.classList.add("is-active", "text-[#950a0a]");
            btn.setAttribute("aria-selected", "true");
            updateYearIndicator(btn);
            scrollTabToCenter(btn);
            filterArchiveByYear(year);
          });
        });

        requestAnimationFrame(() => {
          const activeBtn = yearsInner.querySelector(".is-active");
          updateYearIndicator(activeBtn);
          if (initialYear) scrollTabToCenter(activeBtn);
        });

        filterArchiveByYear(archiveYears[defaultIndex]);
      };

      // Activate a type tab programmatically
      const activateTypeTab = (tab) => {
        typeTabs.forEach((t) => {
          t.classList.remove("is-active", "text-inverse-strong");
          t.classList.add("text-neutral-weaker", "hover:text-neutral-weak");
          t.setAttribute("aria-selected", "false");
        });
        tab.classList.remove("text-neutral-weaker", "hover:text-neutral-weak");
        tab.classList.add("is-active", "text-inverse-strong");
        tab.setAttribute("aria-selected", "true");

        updateTypeIndicator(tab);

        const tabName = tab.getAttribute("data-tab-type");
        showPanel(tabName);

        return tabName;
      };

      // Type tab click handlers
      typeTabs.forEach((tab) => {
        tab.addEventListener("click", () => {
          const tabName = activateTypeTab(tab);
          scrollTabToCenter(tab);

          if (tabName === "archive" && yearsRow && archiveYears.length) {
            yearsRow.classList.remove("hidden");
            buildYearButtons();
          } else if (yearsRow) {
            yearsRow.classList.add("hidden");
          }
        });
      });

      // Parse hash: #upcoming or #archive or #archive/2024
      const parseHash = () => {
        const hash = window.location.hash.replace(/^#/, "");
        if (!hash) return null;
        const parts = hash.split("/");
        return {
          slug: parts[0] || null,
          year: parts[1] || null,
        };
      };

      // Find tab by data-tab-slug
      const findTabBySlug = (slug) => {
        if (!slug) return null;
        for (const tab of typeTabs) {
          if (tab.getAttribute("data-tab-slug") === slug) return tab;
        }
        return null;
      };

      // Initialize: check hash or default to first tab
      const hashParams = parseHash();
      const hashTab = hashParams ? findTabBySlug(hashParams.slug) : null;
      const initialTab = hashTab || typeTabs[0];

      if (initialTab) {
        if (typeIndicator) typeIndicator.style.transition = "none";

        const tabName = activateTypeTab(initialTab);

        if (tabName === "archive" && yearsRow && archiveYears.length) {
          yearsRow.classList.remove("hidden");
          buildYearButtons(hashParams ? hashParams.year : null);
        } else if (yearsRow) {
          yearsRow.classList.add("hidden");
        }

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            updateTypeIndicator(initialTab);
            if (typeIndicator) {
              void typeIndicator.offsetHeight;
              typeIndicator.style.transition = "";
            }

            // Scroll into view when hash is present
            if (hashParams && hashParams.slug) {
              section.scrollIntoView({ behavior: "smooth", block: "start" });
              scrollTabToCenter(initialTab);
            }
          });
        });
      }

      // Listen for hash changes
      window.addEventListener("hashchange", () => {
        const params = parseHash();
        if (!params || !params.slug) return;
        const tab = findTabBySlug(params.slug);
        if (!tab) return;

        const tabName = activateTypeTab(tab);

        if (tabName === "archive" && yearsRow && archiveYears.length) {
          yearsRow.classList.remove("hidden");
          buildYearButtons(params.year);
        } else if (yearsRow) {
          yearsRow.classList.add("hidden");
        }

        requestAnimationFrame(() => {
          updateTypeIndicator(tab);
          section.scrollIntoView({ behavior: "smooth", block: "start" });
          scrollTabToCenter(tab);
        });
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initEventsSection);
  } else {
    initEventsSection();
  }
})();
